import {EventBase} from "shared/utilities/Events/EventManager";

export class FieldDragEnded extends EventBase {
    ReturnType: void;
    public static GetName() {
        return 'FieldDragEnded';
    }
}